import React from 'react';

import { Alert, Paper } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import { useGetAccountIdentityActivityLogs } from '~/hooks/apis/users/useGetAccountIdentityActivityLogs';

import IdentitySignInHistoryTable from './IdentitySignInHistoryTable';
import { getErrorMessage } from './utils';

interface Props {
  accountId: string;
}

export default function IdentitySignInHistory({ accountId }: Props) {
  const { data: logs = [], error } = useGetAccountIdentityActivityLogs(accountId);

  if (error) {
    return (
      <Paper component="section" variant="outlined" sx={{ p: 3 }}>
        <PageSubheader title="Cognito sign-in history" />
        <Alert severity="error">Unable to load Cognito sign-in history: {getErrorMessage(error)}</Alert>
      </Paper>
    );
  }

  return (
    <>
      {logs.map((log) => (
        <Paper key={log.identity_id} component="section" variant="outlined" sx={{ p: 3 }}>
          <IdentitySignInHistoryTable accountId={accountId} log={log} />
        </Paper>
      ))}
    </>
  );
}
